export const PUSH_NOTIFICATION_TO_STACK = 'notifications/PUSH_NOTIFICATION_TO_STACK';
export const POP_NOTIFICATION_FROM_STACK = 'notifications/POP_NOTIFICATION';
export const FLUSH_NOTIFICATION_FROM_STACK = 'notifications/FLUSH_NOTIFICATION_FROM_STACK';
